
export const marketBannerViewModel = (function () {
    let marketBannerEl, marketBannerSelect, modalEl, marketBannerBtn, marketBannerDismiss;

    function init() {
        if (typeof (Storage) == "undefined") {
            return false;
        }

        marketBannerEl = document.getElementById("marketBannerArea");
        marketBannerSelect = document.getElementById("marketBannerSelect");
        modalEl = document.getElementById("websites_worldwide_Modal");
        marketBannerBtn = document.getElementById("marketBannerBtn");
        marketBannerDismiss = document.getElementById("marketBannerDismiss");

        marketBannerBtn.onclick = function(event) {
            event.preventDefault();
            chooseMarket();
        };

        marketBannerDismiss.onclick = function(event) {
            event.preventDefault();
            hideMarketBanner();
        };
        
        if (sessionStorage.getItem("displayBanner") !== "false") {
            marketBannerEl.classList.remove("d-none");
            sessionStorage.setItem("displayBanner", "false");
        } else {
            marketBannerEl.classList.add("d-none");
        }
    }
    
    function hideMarketBanner() {
        marketBannerEl.classList.add("d-none");
        sessionStorage.setItem("displayBanner", "false");
    }

    function chooseMarket() {
        let selectedValue = marketBannerSelect.value;
        
        if (selectedValue === 'modal') {
            let modal = bootstrap.Modal.getOrCreateInstance(modalEl);
            modal.show();
        } else if (selectedValue !== "") {
            window.location.href = selectedValue;
        }
    }

    return {
        hideMarketBanner: hideMarketBanner,
        chooseMarket: chooseMarket,
        init: init
    };

})();

window.marketBannerViewModel = marketBannerViewModel;